(() => {
  if (window.manikaHomeFeedbackInitialized) return;
  window.manikaHomeFeedbackInitialized = true;

  const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  const initializeCategoryControls = (controls) => {
    if (controls.dataset.manikaInitialized) return;

    const section = controls.closest('.index-collections-list');
    const slider = section?.querySelector('[data-grid-slider]');
    const previous = controls.querySelector('[data-manika-category-prev]');
    const next = controls.querySelector('[data-manika-category-next]');
    const slides = slider ? Array.from(slider.querySelectorAll('[data-grid-item]')) : [];
    if (!slider || !previous || !next || slides.length < 2) return;

    controls.dataset.manikaInitialized = 'true';

    const activeIndex = () => {
      const scrollLeft = slider.scrollLeft;
      return slides.reduce((closestIndex, slide, index) => {
        const closestDistance = Math.abs(slides[closestIndex].offsetLeft - scrollLeft);
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        return distance < closestDistance ? index : closestIndex;
      }, 0);
    };

    const updateControls = () => {
      const index = activeIndex();
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    };

    const moveTo = (index) => {
      const targetIndex = Math.min(Math.max(index, 0), slides.length - 1);
      slider.scrollTo({left: slides[targetIndex].offsetLeft, behavior: behavior()});
    };

    previous.addEventListener('click', () => moveTo(activeIndex() - 1));
    next.addEventListener('click', () => moveTo(activeIndex() + 1));
    slider.addEventListener('scroll', updateControls, {passive: true});
    new ResizeObserver(updateControls).observe(slider);
    updateControls();
  };

  const updateTimelineControls = (timeline) => {
    const rows = Array.from(timeline.querySelectorAll('.timeline__row'));
    const previous = timeline.querySelector('[data-manika-timeline-prev]');
    const next = timeline.querySelector('[data-manika-timeline-next]');
    if (!previous || !next) return;

    const activeIndex = Number(timeline.dataset.manikaTimelineIndex || 0);
    previous.disabled = activeIndex <= 0;
    next.disabled = activeIndex >= rows.length - 1;
  };

  const initializeTimeline = (timeline) => {
    if (timeline.dataset.manikaInitialized) return;
    timeline.dataset.manikaInitialized = 'true';

    const rows = Array.from(timeline.querySelectorAll('.timeline__row'));
    const previous = timeline.querySelector('[data-manika-timeline-prev]');
    const next = timeline.querySelector('[data-manika-timeline-next]');
    if (!previous || !next) return;

    const moveTo = (nextIndex) => {
      const index = Math.min(Math.max(nextIndex, 0), rows.length - 1);
      const target = rows[index];
      if (!target) return;

      timeline.dataset.manikaTimelineIndex = index;
      rows.forEach((row, rowIndex) => row.classList.toggle('is-selected', rowIndex === index));
      if (window.matchMedia('(max-width: 749px)').matches) {
        const holder = timeline.querySelector('[data-timeline-rows]');
        holder?.scrollTo({left: target.offsetLeft, behavior: behavior()});
      } else {
        window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: behavior()});
      }
      updateTimelineControls(timeline);
    };

    previous.addEventListener('click', () => moveTo(Number(timeline.dataset.manikaTimelineIndex || 0) - 1));
    next.addEventListener('click', () => moveTo(Number(timeline.dataset.manikaTimelineIndex || 0) + 1));
    timeline.dataset.manikaTimelineIndex = '0';
    updateTimelineControls(timeline);
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-manika-category-controls]').forEach(initializeCategoryControls);
    root.querySelectorAll('[data-manika-timeline-controls]').forEach((controls) => initializeTimeline(controls.closest('timeline-component')));
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
